import(/* webpackMode: "eager" */ "/vercel/path0/src/app/services/floor-plans/page.tsx");
